import {
  CcfBox,
  CcfNewWindowIcon,
  CcfTypography,
  useTranslator,
} from '@nice-ccf/ui-controls';
import styles from '../ccf-consumer-card-external-data-tab/ccf-consumer-card-external-data-tab.module.scss';
import { Card, CardContent, IconButton } from '@mui/material';
import { useSelector } from 'react-redux';
import { getAppSpaceRatio } from '../../../global.app.slice';

/* eslint-disable-next-line */
export interface CcfExternalDataTabLoyaltyInfoProps {
  overviewMinValue: any;
  externalTabData: any;
}

/**@example */
export function CcfExternalDataTabLoyaltyInfo(
  props: CcfExternalDataTabLoyaltyInfoProps
) {
  const { overviewMinValue, externalTabData } = props;
  const appSpaceRatio = useSelector(getAppSpaceRatio);
  const [translate] = useTranslator();

  return (
    <div
      className={styles.detailContainer}
      style={overviewMinValue ? { width: '100%' } : { width: '50%' }}
    >
      <div style={{ width: '100%' }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <CcfTypography
            translationKey={externalTabData.leftPanelData.leftPanelHeader}
            className={styles.headerText}
          ></CcfTypography>
          <IconButton style={{ padding: '8px 0px 0px 0px' }}>
            <CcfNewWindowIcon />
          </IconButton>
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '20px',
            marginBottom: '15px',
          }}
        >
          <CcfTypography
            translationKey={externalTabData.leftPanelData.subTitle}
            className={styles.subHeaderText}
          ></CcfTypography>
          <CcfTypography
            translationKey={externalTabData.leftPanelData.points}
            className={styles.subHeaderText}
          ></CcfTypography>
        </div>
      </div>
      <CcfBox style={{ width: '100%' }}>
        <CcfTypography
          className={styles.recordType}
          translationKey={
            externalTabData.leftPanelData.recentTrips[0].tripType
          }
        ></CcfTypography>
      </CcfBox>
      <CcfBox
        style={{
          width: '100%',
          columnCount: appSpaceRatio <= 40 ? '2' : '3',
          columnGap: '10px',
        }}
      >
        {externalTabData.leftPanelData.recentTrips.map(
          (trip: any, index: any) => (
            <div
              style={{
                height: 'auto',
                // paddingTop: trip.tripType === '' ? '22px' : '0px',
              }}
            >
              <Card
                variant="outlined"
                style={{ marginBottom: '5px', cursor: 'pointer' }}
              >
                <CardContent className={styles.recordContent}>
                  <CcfBox className={styles.recordDetailsBlock}>
                    <CcfBox className={styles.recordMinParentContainer}>
                      <CcfBox className={styles.recordDetails}>
                        <div>
                          <img
                            src={trip.imageUrl}
                            style={{ width: '100%', height: '100%' }}
                            alt={trip.imageUrl}
                          />
                        </div>
                        <CcfTypography
                          translationKey={trip.tripTiltle}
                          className={styles.title}
                        ></CcfTypography>
                        <span className={styles.subTitle}>
                          {translate('confirmation') +
                            ' ' +
                            trip.confirmationId}
                        </span>
                        <CcfTypography
                          translationKey={trip.date}
                          className={styles.subTitle}
                        ></CcfTypography>
                      </CcfBox>{' '}
                    </CcfBox>
                  </CcfBox>
                </CardContent>
              </Card>{' '}
            </div>
          )
        )}{' '}
      </CcfBox>{' '}
      <CcfBox style={{ width: '100%' }}>
        <CcfTypography
          className={styles.recordType}
          translationKey={
            externalTabData.leftPanelData.leftPanelSubHeader[0].tripType
          }
        ></CcfTypography>
      </CcfBox>
      <CcfBox
        style={{
          width: '100%',
          columnCount: appSpaceRatio <= 40 ? '2' : '3',
          columnGap: '10px',
        }}
      >
        {externalTabData.leftPanelData.leftPanelSubHeader.map(
          (trip: any, index: any) => (
            <div
              style={{
                height: 'auto',
                paddingTop: '0px',
              }}
            >
              <Card
                variant="outlined"
                style={{ marginBottom: '5px', cursor: 'pointer' }}
              >
                <CardContent className={styles.recordContent}>
                  <CcfBox className={styles.recordDetailsBlock}>
                    <CcfBox className={styles.recordMinParentContainer}>
                      <CcfBox className={styles.recordDetails}>
                        <div>
                          <img
                            src={trip.imageUrl}
                            style={{ width: '100%', height: '100%' }}
                            alt={trip.imageUrl}
                          />
                        </div>
                        <CcfTypography
                          translationKey={trip.tripTiltle}
                          className={styles.title}
                        ></CcfTypography>
                        <span className={styles.subTitle}>
                          {translate('confirmation') +
                            ' ' +
                            trip.confirmationId}
                        </span>
                        <CcfTypography
                          translationKey={trip.date}
                          className={styles.subTitle}
                        ></CcfTypography>
                      </CcfBox>{' '}
                    </CcfBox>
                  </CcfBox>
                </CardContent>
              </Card>{' '}
            </div>
          )
        )}
      </CcfBox>
    </div>
  );
}

export default CcfExternalDataTabLoyaltyInfo;
